import { useMutation } from '@tanstack/react-query'

import { apiClient } from '../../lib/client.js'

/** « Je souhaite recevoir un devis similaire », depuis une proposition expirée. */
export const useRequestMyEstimateSimilarMutation = () =>
  useMutation({
    mutationFn: async (responseId: string) => {
      const response = await apiClient.client.post(
        `/me/estimate-responses/${responseId}/similar-request`
      )
      return response.data
    },
  })
